import React from 'react';
import { LogOut } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const LogoutModal = () => {
  const app = useAppContext();

  return (
    <Modal
      isOpen={app.showLogoutConfirmModal}
      onClose={() => app.setShowLogoutConfirmModal(false)}
      size="sm"
    >
      <div className="modal__header">
        <div className="modal__icon-wrapper modal__icon-wrapper--danger">
          <LogOut size={28} />
        </div>
        <h2 className="modal__title">Confirm Logout</h2>
        <p className="modal__subtitle">Are you sure you want to log out?</p>
      </div>
      <div className="modal__body">
        <div className="confirm-modal__actions">
          <button className="btn btn-danger btn-full" onClick={app.handleLogoutCleanup}>
            Yes, Log Out
          </button>
          <button
            className="btn btn-secondary btn-full"
            onClick={() => app.setShowLogoutConfirmModal(false)}
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModal;
